import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkAuth } from "./redux/userSlice";
import { RouterProvider } from "react-router-dom";
import routes from "./router";
import Loader from "./components/Loader";

const AppWrapper = () => {
  const dispatch = useDispatch();
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {

    dispatch(checkAuth()).finally(() => setAuthChecked(true));

  }, [dispatch]);

  useEffect(() => {
    const theme = localStorage.getItem("facturize_theme") || "light";
    document.documentElement.setAttribute("data-theme", theme);
  }, []);

  if (!authChecked) {
    return <Loader />;
  }

  return <RouterProvider router={routes} />;
};

export default AppWrapper;